import styled from 'styled-components';

const Button = styled.button`
  font-weight: 700;
  font-size: 11px;
  line-height: 15px;
  color: #959595;
  width: 129px;
  height: 53px;
  background: #f5f5f5;
  border-radius: 22px;
  border: none;
  cursor: pointer;
  &:not(:last-of-type) {
    margin-right: 7px;
  }

  &:hover {
    background: #e6e6e6;
  }

  &.active {
    background-color: #2757f4;
    color: #fff;

    &:hover {
      opacity: 0.9;
    }
  }

  &.hover-active {
    &:hover {
      background-color: #2757f4;
      color: #fff;
    }
  }
`;

export default Button;



// WEBPACK FOOTER //
// ./src/routes/Home/Button.js